import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brTablet = createBreakpoint('s');
const brDesk = createBreakpoint('m');
const brLarge = createBreakpoint('l');
const brXLarge = createBreakpoint('xl');

export const mainCls = 'csa-page-grid';

export default {
  [mainCls]: {
    [brDesk]: {
      flexWrap: 'nowrap',
      margin: '18px 8px 0',
    },
    [brLarge]: {
      margin: '18px 32px 0',
    },
    [brXLarge]: {
      margin: '18px auto 0',
      maxWidth: 1302,
    },
  },
  [`${mainCls}__col`]: {
    display: 'none',
    [brDesk]: {
      display: 'block',
      width: 300,
      order: 1,
    },
    [brLarge]: {
      width: 320,
    },
  },
  [`${mainCls}__main`]: {
    paddingBottom: 60,
    maxWidth: '100vw',
    [brDesk]: {
      order: 2,
      marginLeft: 'auto',
      paddingBottom: 80,
      maxWidth: 'calc(100% - 308px)',
      paddingBottom: '80px',
    },
    [brLarge]: {
      maxWidth: 'calc(100% - 352px)',
    }
  },
};